import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteAppointmentsService = async (
  appointmentId: string,
): Promise<void> => {
  await jhsfBookingsApi.delete(`/appointments/${appointmentId}`);
};

export default deleteAppointmentsService;
